interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-3xl ${isCenter ? "mx-auto text-center" : ""}`}>
      <span
        className={`inline-flex items-center gap-2 rounded-full bg-primary-100/80 px-3 py-1 text-xs font-medium tracking-wide text-primary-700 ${
          isCenter ? "justify-center" : ""
        }`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
        {eyebrow}
      </span>
      <h2 className="mt-4 text-2xl font-semibold leading-snug text-foreground-950 md:text-4xl">{title}</h2>
      {desc ? <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p> : null}
    </div>
  );
}